import { CryptoWallet } from "@models";
import { TYPE_NAME_SECURITY } from "@helpers/constants";

export class SecurityTokenWallet extends CryptoWallet {
	public static TypeName = TYPE_NAME_SECURITY;
}
